import React, { Suspense } from "react";
import Router from "./routes";
import UXloader from "./components/layouts/UXloader";
import { BrowserRouter } from "react-router-dom";
import UXErrorBoundary from "./components/layouts/UXErrorBoundary";

export default function App() {
  return (
    <Suspense fallback={<UXloader />}>
      <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
        <UXErrorBoundary>
          <Router />
        </UXErrorBoundary>
      </BrowserRouter>
    </Suspense>
  );
}
